/* CustomCohorts.ts */

/* Interfaces */
import { DateRestrictionType } from "src/shared/interfaces/custom-cohorts/DateRestriction";
import { Operator } from "src/shared/interfaces/custom-cohorts/Operator";
import { BasicErrorProps } from "src/shared/interfaces/error/Error";

export enum Keys {
  ENTITY = "entity",
  DATE_RESTRICTION = "dateRestriction",
  VALUE = "value",
  VALUES = "values",
  BOUNDARIES = "boundaries",
}

export enum EntityType {
  BOOLEAN = "boolean",
  NUMERIC = "numeric",
  CONCEPT = "concept",
  UNSUPPORTED = "unsupported",
}

export enum Status {
  SAVED = "saved",
  EDITING = "editing",
  MODIFIED = "modified",
}

interface CustomCohortsByDiseaseProps {
  cohorts: CustomCohortsProps[];
  customCohortsStr?: string;
}

export interface CustomCohortsState {
  currentDiseaseId?: string;
  customCohortsByDisease: Record<
    string,
    CustomCohortsByDiseaseProps
  >;
  customCohort: CustomCohortsProps;
  error?: BasicErrorProps;
}

export interface CustomCohortsProps {
  id: string;
  createdAt?: string;
  modifiedAt?: string;
  status?: Status;
  name: string;
  data?: BasicProps | LogicalProps;
  show: boolean;
}

export interface BasicProps {
  entity: EntityProps;
  unit?: string;
  dateRestriction: DateRestrictionType;
  value?: boolean;
  values?: string[];
  boundaries?: BoundariesProps;
}

export interface LogicalProps {
  operator: Operator;
  conditions: (LogicalProps | BasicProps)[];
}

export interface EntityProps {
  name: string;
  type: EntityType;
  options?: boolean[] | string[];
  range?: RangeProps;
}

export interface RangeProps {
  min: number;
  max: number;
}

export interface BoundariesProps {
  lowerBound: number;
  upperBound: number;
}

export interface ProcessedCohort {
  entity_name?: string;
  date_restriction?: string;
  value?: boolean;
  values?: string[];
  lower_bound?: number;
  upper_bound?: number;
  operator?: string;
  conditions?: ProcessedCohort[];
}
